import React from 'react';
import dayjs from 'dayjs';
import { Box, FormControlLabel, Paper, Switch, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

const toIso = (value) => value?.isValid() ? value.toISOString() : null;

export default function FanPollScheduleEditor({ startDate, endDate, endDateError, onChange }) {
    return (
        <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle1" fontWeight={700}>Schedule</Typography>
            <Typography variant="caption" color="text.secondary">
                Times are shown locally and saved as UTC.
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box sx={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: 1.5, mt: 1.5, alignItems: 'center' }}>
                    <FormControlLabel
                        control={<Switch checked={Boolean(startDate)} onChange={(event) => onChange('startDate', event.target.checked ? dayjs().toISOString() : null)} />}
                        label="Set start date"
                    />
                    <DateTimePicker
                        label="Start date"
                        disabled={!startDate}
                        value={startDate ? dayjs(startDate) : null}
                        onChange={(value) => onChange('startDate', toIso(value))}
                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                    />
                    <FormControlLabel
                        control={<Switch checked={Boolean(endDate)} onChange={(event) => onChange('endDate', event.target.checked ? dayjs().add(7, 'day').toISOString() : null)} />}
                        label="Set end date"
                    />
                    <DateTimePicker
                        label="End date"
                        disabled={!endDate}
                        value={endDate ? dayjs(endDate) : null}
                        onChange={(value) => onChange('endDate', toIso(value))}
                        slotProps={{ textField: { size: 'small', fullWidth: true, error: Boolean(endDateError), helperText: endDateError } }}
                    />
                </Box>
            </LocalizationProvider>
        </Paper>
    );
}
